module.exports = __webpack_public_path__ + "img/1558340866.e786d2cc.jpg";